import React from 'react'

const LazyLoader = () => {
  return (
    <div className='lazy-loader'>
        <div class="lds-hourglass"></div>
    </div>
  )
}

export default LazyLoader